import { graphql, commitMutation, Environment } from 'react-relay/legacy';

import {
    userProfileMutation as Mutation,
    EditPersonalProfileInput,
} from './__generated__/userProfileMutation.graphql';

const mutation = graphql`
    mutation userProfileMutation($input: EditPersonalProfileInput!) {
        editPersonalProfile(input: $input) {
            user {
                profile {
                    firstName
                    lastName
                    zipCode
                    currency
                    measurementUnit
                }
            }
        }
    }
`;

type Args = EditPersonalProfileInput & { onCompleted?: () => void; onError?: () => void };

export function userProfileMutation(environment: Environment, args: Args): void {
    const {
        firstName,
        lastName,
        userServiceId,
        zipCode,
        currency,
        measurementUnit,
        onCompleted,
        onError,
    } = args;
    commitMutation<Mutation>(environment, {
        mutation,
        variables: {
            input: {
                firstName,
                lastName,
                userServiceId,
                zipCode,
                currency,
                measurementUnit,
            },
        },
        onCompleted,
        onError,
    });
}
